import { http } from "utils/http";

export const getDictionaryListApi = (async (baseUrl=undefined,url,search='',params={} ,secendUrl=null , id=undefined) => await http({
    baseURL:  baseUrl,
    url: (id&&secendUrl)? secendUrl:url,
    method: 'get',
    params: {
        searchString:search,
        Id:id,
        ...params
    }
}).then((res) => {

    return (res.data.Data!=undefined||res.data.Data==null)?res.data.Data:res.data
}).catch((err) => {

    return Promise.reject( err);
})
)